/* Naviwerk – Header: Mega-Menü, mobiles Menü, Suche, mitlaufender Header, Mini-Fahrzeugfinder */
(() => {
  if (customElements.get('nw-header')) return;

  class NwHeader extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true }); return; }
      if (this._init) return; this._init = true;
      this.items = [...this.querySelectorAll('[data-hd-item]')];
      this.drawer = this.querySelector('[data-hd-drawer]');
      this.burger = this.querySelector('[data-hd-burger]');
      this.searchBox = this.querySelector('[data-hd-searchbox]');
      this.scrim = this.querySelector('[data-hd-scrim]');
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.timer = null;

      // Desktop: Hover mit kleiner Verzögerung, Klick/Tastatur als Alternative
      this.items.forEach((li) => {
        const trig = li.querySelector('[data-hd-trigger]');
        li.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && this.isDesktop()) { clearTimeout(this.timer); this.timer = setTimeout(() => { if (!li.classList.contains('is-open')) { this.open(li); li._hover = true; } }, 90); } });
        li.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && this.isDesktop()) { clearTimeout(this.timer); this.timer = setTimeout(() => this.close(li), 160); } });
        trig.addEventListener('click', (e) => {
          // Klick öffnet immer zuerst das Dropdown (keine direkte Weiterleitung). War es per Maus-Hover schon offen, bleibt es offen.
          e.preventDefault();
          clearTimeout(this.timer);
          if (li.classList.contains('is-open') && !li._hover) this.close(li);
          else { this.open(li); li._hover = false; }
        });
        li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) this.close(li); });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const o = this.items.find((x) => x.classList.contains('is-open'));
        if (o) { this.close(o); o.querySelector('[data-hd-trigger]').focus(); }
        if (this.searchBox && !this.searchBox.hidden) this.toggleSearch(false);
        if (this.drawer && !this.drawer.hidden) this.toggleDrawer(false);
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.items.forEach((x) => this.close(x)); });

      // Mobil
      this.burger?.addEventListener('click', () => this.toggleDrawer(this.drawer.hidden));
      this.querySelectorAll('[data-hd-acc] > button').forEach((b) => b.addEventListener('click', () => {
        const li = b.parentElement; const open = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', String(open)); li.classList.toggle('is-open', open);
      }));
      this.drawer?.addEventListener('click', (e) => { if (e.target.closest('a[href]') || e.target.closest('[data-nw-ask]')) this.toggleDrawer(false); });

      // Suche
      this.querySelector('[data-hd-search]')?.addEventListener('click', () => this.toggleSearch(this.searchBox.hidden));
      this.querySelector('[data-hd-search-close]')?.addEventListener('click', () => this.toggleSearch(false));
      this.scrim?.addEventListener('click', () => { this.toggleSearch(false); this.toggleDrawer(false); });

      // Mitlaufender Header
      this.mode = this.dataset.sticky || 'smart';
      if (this.mode !== 'none') this.section.classList.add('nw-hd-sticky');
      let last = window.scrollY; let ticking = false;
      const onScroll = () => {
        const y = window.scrollY;
        this.section.classList.toggle('nw-hd-scrolled', y > 8);
        if (this.mode === 'smart') {
          const busy = this.items.some((x) => x.classList.contains('is-open')) || (this.drawer && !this.drawer.hidden) || (this.searchBox && !this.searchBox.hidden);
          if (!busy && y > 160 && y - last > 6) this.section.classList.add('nw-hd-hidden');
          else if (last - y > 6 || y < 160) this.section.classList.remove('nw-hd-hidden');
        }
        last = y; ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
      onScroll();
      const setH = () => document.documentElement.style.setProperty('--nw-hd-h', `${this.querySelector('.nw-hd__bar').offsetHeight}px`);
      setH(); window.addEventListener('resize', setH, { passive: true });
      // Andere Skripte (Warenkorb) erwarten evtl. ein reveal() am Header
      this.reveal = () => this.section.classList.remove('nw-hd-hidden');
    }
    isDesktop() { return window.innerWidth >= 1280; }
    open(li) {
      this.items.forEach((x) => { if (x !== li) this.close(x); });
      li.classList.add('is-open'); li.querySelector('[data-hd-trigger]').setAttribute('aria-expanded', 'true');
      this.section.classList.add('nw-hd-menu-open');
    }
    close(li) {
      li.classList.remove('is-open'); li._hover = false; li.querySelector('[data-hd-trigger]')?.setAttribute('aria-expanded', 'false');
      if (!this.items.some((x) => x.classList.contains('is-open'))) this.section.classList.remove('nw-hd-menu-open');
    }
    lock(on) { document.documentElement.classList.toggle('nw-hd-lock', on); }
    toggleDrawer(on) {
      if (!this.drawer) return;
      if (on) {
        this.toggleSearch(false);
        // Header sofort einblenden (falls beim Runterscrollen versteckt), sonst fehlen Logo und Menüzeile
        const sec = this.section; const tr = sec.style.transition;
        sec.style.transition = 'none'; sec.classList.remove('nw-hd-hidden'); void sec.offsetHeight; sec.style.transition = tr;
        this.drawer.style.top = `${Math.max(0, this.querySelector('.nw-hd__bar').getBoundingClientRect().bottom)}px`;
        this.drawer.hidden = false; requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      }
      else { this.drawer.classList.remove('is-open'); setTimeout(() => { if (!this.drawer.classList.contains('is-open')) this.drawer.hidden = true; }, 320); }
      this.burger.setAttribute('aria-expanded', String(!!on)); this.burger.setAttribute('aria-label', on ? 'Menü schließen' : 'Menü öffnen');
      this.classList.toggle('is-drawer', !!on); this.lock(!!on);
    }
    toggleSearch(on) {
      if (!this.searchBox) return;
      if (on) { this.toggleDrawer(false); this.searchBox.hidden = false; this.scrim.hidden = false; requestAnimationFrame(() => { this.searchBox.classList.add('is-open'); this.scrim.classList.add('is-open'); this.searchBox.querySelector('input[name="q"]').focus(); }); }
      else { this.searchBox.classList.remove('is-open'); this.scrim.classList.remove('is-open'); setTimeout(() => { this.searchBox.hidden = true; this.scrim.hidden = true; }, 250); }
    }
  }
  customElements.define('nw-header', NwHeader);

  /* Mini-Fahrzeugfinder im Mega-Menü – alle Marken mit Daten (#nw-bmw-data + #nw-vehicle-data) */
  const hdNorm = (x) => String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  class NwHdFinder extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true }); return; }
      if (this._init) return; this._init = true;
      this.loadDb();
      this.f = {}; this.querySelectorAll('[data-hdf]').forEach((el) => { this.f[el.dataset.hdf] = el; });
      this.go = this.querySelector('[data-hdf-go]'); this.note = this.querySelector('[data-hdf-note]');
      this.base = (this.dataset.finder || '/pages/fahrzeugfinder').split('#')[0];
      Object.values(this.f).forEach((el) => el.addEventListener('change', () => this.update(el.dataset.hdf)));
      this.update();
    }
    opts(sel, list, ph) {
      const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      sel.innerHTML = `<option value="">${ph}</option>` + list.map(([v, t]) => `<option value="${esc(v)}">${esc(t)}</option>`).join('');
      sel.disabled = !list.length;
    }
    /* Fahrzeugdaten lesen – erneut versuchen, falls sie beim Start noch nicht im Dokument waren */
    loadDb() {
      const read = (id) => { const el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } };
      const bmw = read('nw-bmw-data'); const more = read('nw-vehicle-data');
      this.db = [];
      if (bmw && bmw.series) this.db.push({ brand: bmw.brand || 'BMW', series: bmw.series });
      if (more && Array.isArray(more.brands)) more.brands.forEach((x) => { if (x && x.series) this.db.push(x); });
      this._hasMore = !!(more && Array.isArray(more.brands));
      return this.db;
    }
    bd() {
      const b = hdNorm(this.f.brand.value); if (!b) return null;
      if (!this._hasMore) this.loadDb();
      return this.db.find((x) => hdNorm(x.brand) === b) || null;
    }
    series() { const d = this.bd(); return d ? d.series.find((x) => x.id === this.f.series.value) || null : null; }
    model() { const se = this.series(); return se ? se.models.find((m) => m.id === this.f.model.value) || null : null; }
    update(changed) {
      const f = this.f; const brand = f.brand.value; const d = this.bd();
      if (changed === 'brand') {
        this.opts(f.series, d ? d.series.map((x) => [x.id, x.name]) : [], d ? 'Baureihe wählen' : '–');
        this.opts(f.model, [], '–'); this.opts(f.year, [], '–');
        if (d && d.series.length === 1) { f.series.value = d.series[0].id; changed = 'series'; }
      }
      if (changed === 'series') {
        const se = this.series();
        this.opts(f.model, se ? se.models.map((m) => [m.id, m.label || m.code || m.id]) : [], se ? 'Modell wählen' : '–');
        if (se && se.models.length === 1) { f.model.value = se.models[0].id; changed = 'model'; } else this.opts(f.year, [], '–');
      }
      if (changed === 'model') {
        const m = this.model(); const ys = []; if (m) for (let y = m.to; y >= m.from; y--) ys.push([y, y]);
        this.opts(f.year, ys, ys.length ? 'Baujahr wählen' : '–');
      }
      const q = new URLSearchParams();
      if (brand) q.set('nw_brand', brand.replace(/ Marke$/, ''));
      if (d && f.model.value) q.set('nw_v', f.model.value);
      if (d && f.model.value && f.year.value) q.set('nw_y', f.year.value);
      this.go.href = `${this.base}${q.toString() ? `?${q}` : ''}#fahrzeugfinder`;
      const other = brand && !d;
      this.note.hidden = !other;
      if (other) this.note.textContent = 'Für diese Marke erstellen wir Ihnen gern ein individuelles Angebot.';
      this.go.querySelector('span').textContent = other ? 'Angebot anfragen' : 'Passende Systeme anzeigen';
    }
  }
  customElements.define('nw-hd-finder', NwHdFinder);
})();
